import * as React from "react";
import { PromptContext } from "../mobxStores/prompt/prompt";

export function useSetPromptOnDiscard(fn?: () => void) {
  React.useEffect(() => {
    PromptContext.setOnDiscard(fn);
  }, []);
}
